import React from 'react';
import { Link } from 'react-router-dom';

const SkillDevelopment = () => {
  return (
    <div>
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("/img/banner/banner-skill.jpg")' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Skill Development</h1>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li>Skill Development</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row mt-n2-9">
            {/* Sidebar */}
            <div className="col-lg-4 mt-2-9 order-2 order-lg-1">
              <div className="sidebar me-xl-1-9">
                <div className="widget mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <h2 className="mb-4 h4">Our Work</h2>
                  <ul className="list-unstyled menu m-0">
                    <li className="active"><Link to="/skill-development">Skill Development<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/education">Education<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/health">Health<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/abled">Inclusion of Differently Abled<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/sports">Sports<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/community-initiatives">Community Initiatives<i className="ti-arrow-right"></i></Link></li>
                    <li><Link to="/livelihoods">Livelihoods<i className="ti-arrow-right"></i></Link></li>
                  </ul>
                </div>

                <div className="widget mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <h2 className="mb-4 h4">Follow us</h2>
                  <div className="widget-content">
                    <ul className="social-icon-style2 list-unstyled ps-0">
                      <li className="me-1 d-inline-block"><Link to="https://www.facebook.com/www.shamayitamath.org?mibextid=ZbWKwL"target="blank"><i className="fab fa-facebook-f"></i></Link></li>
                      <li className="me-1 d-inline-block"><Link to="https://youtube.com/@shamayitamath2956?si=s7HKE99MD6pY6Kpb"target="blank"><i className="fa-brands fa-youtube"></i></Link></li>
                      <li className="me-1 d-inline-block"><Link to="https://www.instagram.com/shamayitamath?utm_source=ig_web_button_share_sheet&igsh=ODdmZWVhMTFiMw=="target="blank"><i className="fab fa-instagram"></i></Link></li>
                      <li className="me-0 d-inline-block"><Link to="https://www.linkedin.com/company/shamayitamath/?viewAsMember=true"target="blank"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-8 mt-2-9 order-1 order-lg-2">
              <div>
                <div className="mb-1-9 mb-lg-5 image-hover wow fadeInUp" data-wow-delay="100ms">
                  <img src="/img/service/service-details-01.jpg" alt="..." className="border-radius-10" />
                </div>
                <p className="mb-3 wow fadeInUp" data-wow-delay="100ms">
                  The thematic area of skill development constitutes two programs aimed at advancing individuals and communities through training and entrepreneurship.
                </p>

                <h2 className="mb-4 wow fadeInUp text-primary pt-3" data-wow-delay="100ms">PNBSMRSETI:</h2>
                <p className="mb-3 wow fadeInUp" data-wow-delay="100ms">
                  Shamayita Math Rural Development & Self Employment Training Institute is a dedicated skill-building institute that caters to the youth of Bankura. An outcome of a partnership between Punjab National Bank (earlier United Bank) and Shamayita Math, the institute came into being in 2008. The initiative spurs the youth to become self-dependent by undergoing training in the vocations of agriculture, beautician skills, tailoring, food processing, and so on followed by assistance in setting up their ventures.
                </p>
                <h4 class="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">Objectives of SMRSETI: </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-4">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Empower rural youth for self-employment through motivation and training.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-4">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        A major concentration is on training youth from excluded segments.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Facilitate credit linkage with banks to initiate and sustain micro-enterprises
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row mt-n1-9">
                  <div className="col-md-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                    <div className="image-hover">
                      <img src="img/service/SMRSETI-1.jpg" alt="..." className="border-radius-10" />
                    </div>
                  </div>

                  <div className="col-md-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                    <div className="image-hover">
                      <img src="img/service/SMRSETI-2.jpg" alt="..." className="border-radius-10" />
                    </div>
                  </div>
                </div>


                {/* <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">Impact of COVID-19 and Revival</h4>
                <p className="mb-5 wow fadeInUp" data-wow-delay="100ms">
                  While the initiative was doing well for years, the operation was adversely affected when the world was hit by the COVID-19 pandemic in 2020. This saw the demand nose dividing leading to its temporary closure in the same year. Keen to revive the unit and provide local income generation opportunities to not only women but also men, Shamayita Math relaunched the initiative in 2021 by focusing on the production of uniforms for Shamayita Convent School as well as hostel dresses. The effort has gathered pace and currently 15 people, a mix of male and female tailors are working on this initiative. The effort is to take uniform production orders from other schools in Bankura as well as look for other opportunities such as hospital dresses and so on.
                </p> */}


                <h2 className="mb-4 wow fadeInUp text-primary pt-3" data-wow-delay="100ms">Nationally Accredited Initiative:  </h2>
                <p className="mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  Shamayita Math hosts the training programs, which are aligned with the National Skill Qualification Framework (NSQF). The institute scouts for, mobilizes, and selects interested and promising youth for the program and offers short-term skill-building training, lasting from 10 to 30 days. While undergoing training, the youth are provided meals and accommodation at no cost. Upon completion of the course, the institute assists them in securing financial support from banks to set up and operate their businesses. The institute has received a Grade "AA" award from the Ministry of Rural Development and the National Centre for Excellence of RSETIs for 2022-2023.
                </p>

                <h2 className="mb-4 wow fadeInUp text-primary pt-3" data-wow-delay="100ms">Diverse Training Programs:</h2>
                <p className="mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  The training program offers a diverse range of courses tailored to enhance skills and promote entrepreneurship among participants. Notable among them is the General Entrepreneurship Development Program (EDP) which provides essential business knowledge and skills for aspiring entrepreneurs. The other courses comprise the women’s tailor and beauty parlor management courses aimed at enabling women to attain economic self-sufficiency. The Krishi Udyami course equips participants with essential agricultural skills. Similarly, courses like jute product development, soft toy making, and custom jewelry creation provide insights into crafting and entrepreneurial ventures.
                </p>
                <p className="mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  For those interested in livestock and food production, courses such as goat rearing, dairy farming, vermicompost making, and poultry are available. Additionally, the fast-food stall, papad, pickle and masala powder production, and mushroom cultivation courses focus on practical skills for starting small food businesses and culinary entrepreneurship. Moreover, the homemade Agarbatti (aroma sticks) making course provides an opportunity to learn a unique skill. The training programs encourage participants to explore entrepreneurial avenues for achieving self-reliance and community upliftment.
                </p>

                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">Impacts:</h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-4">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        The training programs have maintained a special focus on individuals from Below Poverty Line (BPL), Scheduled Caste (SC), Scheduled Tribe (ST), and other backward sections.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3 mb-4">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        Making a significant impact, the initiative has trained 8,775 youth so far.
                      </span>
                    </div>
                    <div className="d-flex align-items-center border border-color-light-black p-3">
                      <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                      <span className="ms-3 text-dark fw-bold">
                        63.47 percent of the trained youth attained self-sufficiency by setting up their micro-enterprises.
                      </span>
                    </div>
                  </div>
                </div>

                <h2 className="mb-4 wow fadeInUp text-primary pt-3" data-wow-delay="100ms">Harnessing Local Craft:</h2>
                <p className="mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  Simultaneously, the local embroidery, which was the unique element of the venture, got a new lease of life with the initiation of a project near Durgapur in 2024. The project involves local women adept in the art of wool-based embroidery, which is unique to the area, to produce women’s apparel. A fashion designer is associated with the project and is assisting the women imbibe different styles and designs in their work as well as the marketing efforts. An embroidery-based apparel production unit in Durgapur- Jagriti that will harness the tailoring and embroidery skills of local women has come up recently.
                </p>

                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">Impacts:</h4>
                  <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                    <div className="col-md-12 mb-4 mb-md-0">
                      <div className="d-flex align-items-center border border-color-light-black p-3 mb-4">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">Harnessing local skills that come naturally to women.</span>
                      </div>
                      <div className="d-flex align-items-center border border-color-light-black p-3 mb-4">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">Fulfilling aspiration by providing an income-making opportunity locally.</span>
                      </div>
                      <div className="d-flex align-items-center border border-color-light-black p-3 mb-4">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">Creating rural and urban linkages by taking the artistry of hinterlands to cities.</span>
                      </div>
                      <div className="d-flex align-items-center border border-color-light-black p-3">
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">Increased participation in decision-making by women at the household and community levels, contributing to gender parity.</span>
                      </div>
                    </div>
                  </div>
                  <h2 className="mb-4 wow fadeInUp text-primary pt-3" data-wow-delay="100ms">Sambriti - Empowering Rural Women through Skill Training:</h2>
                  <p className="mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                    In 2000, a unit was established to train local women in hand embroidery and dressmaking, leading to the creation of "Sambriti", a boutique dress-designing facility. It provided stitching training to young rural women, enabling them to create various items and earn a living. It developed a unique clothing line and opened outlets in Durgapur, Kolkata, and Dhanbad, catering to urban women and serving as training centers for apparel production. It promoted traditional handicraft products through various exhibitions.
                  </p> 

                  <div className="row mt-n1-9">
                    <div className="col-md-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                      <div className="image-hover">
                        <img src="img/service/Sambriti-1.jpg" alt="..." className="border-radius-10" />
                      </div>
                    </div>

                    <div className="col-md-6 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
                      <div className="image-hover">
                        <img src="img/service/Sambriti-2.jpg" alt="..." className="border-radius-10" />
                      </div>
                    </div>
                  </div>

              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </div>
  );
};

export default SkillDevelopment;
